/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The countdown is based on the real clock, so it stays accurate when the tab is in the background, and the alarm still rings when the time is up.`)
};

const es_timer_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. La cuenta regresiva se basa en el reloj real, así que se mantiene precisa cuando la pestaña está en segundo plano, y la alarma sigue sonando cuando se acaba el tiempo.`)
};

const de_timer_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Der Countdown basiert auf der echten Uhrzeit, bleibt also auch im Hintergrund-Tab genau, und der Alarm ertönt trotzdem, wenn die Zeit abgelaufen ist.`)
};

const nl_timer_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. De aftelling is gebaseerd op de echte klok, dus die blijft nauwkeurig als het tabblad op de achtergrond staat, en het alarm gaat nog steeds af als de tijd om is.`)
};

const fr_timer_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Le compte à rebours se base sur l’horloge réelle, il reste donc précis lorsque l’onglet est en arrière-plan, et l’alarme sonne toujours une fois le temps écoulé.`)
};

const it_timer_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Il countdown si basa sull'orologio reale, quindi resta preciso anche quando la scheda è in background, e l'allarme suona comunque allo scadere del tempo.`)
};

const pt_br2_timer_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. A contagem regressiva é baseada no relógio real, então ela permanece precisa quando a aba está em segundo plano, e o alarme toca normalmente quando o tempo acaba.`)
};

const pt_timer_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. A contagem decrescente baseia-se no relógio real, por isso mantém-se exata quando o separador está em segundo plano, e o alarme continua a tocar quando o tempo termina.`)
};

const ja_timer_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。カウントダウンは実際の時計を基準にしているため、タブがバックグラウンドにあっても正確に動作し、時間になるとアラームも鳴ります。`)
};

const zh_timer_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会。倒计时基于真实时钟运行，因此即使标签页在后台也能保持准确，时间到时闹铃依然会响起。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_hub_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_hub_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_hub_faq2_a", locale)
	if (locale === "en") return en_timer_hub_faq2_a(inputs)
	if (locale === "es") return es_timer_hub_faq2_a(inputs)
	if (locale === "de") return de_timer_hub_faq2_a(inputs)
	if (locale === "nl") return nl_timer_hub_faq2_a(inputs)
	if (locale === "fr") return fr_timer_hub_faq2_a(inputs)
	if (locale === "it") return it_timer_hub_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_hub_faq2_a(inputs)
	if (locale === "pt") return pt_timer_hub_faq2_a(inputs)
	if (locale === "ja") return ja_timer_hub_faq2_a(inputs)
	return zh_timer_hub_faq2_a(inputs)
};